// 64 × 64 = 4,096 combinations.

export const ADJECTIVES = [
  'hell','dunkel','lebhaft','still','sanft','stark','schwach','leicht',
  'schwer','hoch','tief','weit','eng','schnell','langsam','groß',
  'blass','schwarz','weiß','rot','blau','grün','gelb','golden',
  'silbern','kupfern','bernstein','purpur','koralle','elfenbein','asch','scharlach',
  'kalt','warm','frisch','lau','trocken','feucht','zart','hart',
  'scharf','weich','glatt','rau','glänzend','matt','rein','frei',
  'alt','neu','erste','letzt','mild','fein','dick','kurz',
  'lang','rund','eckig','schmal','wild','edel','nah','fern',
]

export const NOUNS = [
  'Mond','Sonne','Stern','Himmel','Wolke','Wind','Regen','Schnee',
  'Sturm','Bogen','Nebel','Tau','Reif','Blitz','Morgen','Abend',
  'Meer','Fluss','See','Wald','Berg','Tal','Stein','Sand',
  'Höhle','Fall','Hügel','Ebene','Insel','Klippe','Ufer','Wiese',
  'Rose','Lilie','Iris','Nelke','Veilchen','Mohn','Jasmin','Lavendel',
  'Eiche','Ahorn','Weide','Zeder','Kiefer','Buche','Linde','Ulme',
  'Vogel','Spatz','Schwalbe','Nachtigall','Adler','Falke','Rabe','Reiher',
  'Schwan','Wolf','Fuchs','Hase','Hirsch','Bär','Luchs','Eichhorn',
]
